import { PaymentRequestReason } from '@mews-commander/data-access';
import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';

const PaymentRequestReasonTextKeyMap = {
    [PaymentRequestReason.Deposit]: TextKey.PaymentRequestReasonDeposit,
    [PaymentRequestReason.Fee]: TextKey.PaymentRequestReasonFee,
    [PaymentRequestReason.Other]: TextKey.PaymentRequestReasonOther,
    [PaymentRequestReason.PaymentCardDeclined]: TextKey.PaymentRequestReasonPaymentCardDeclined,
    [PaymentRequestReason.PaymentCardMissing]: TextKey.PaymentRequestReasonPaymentCardMissing,
    [PaymentRequestReason.Prepayment]: TextKey.PaymentRequestReasonPrepayment,
    [PaymentRequestReason.RecurringPayment]: TextKey.PaymentRequestReasonRecurringPayment,
};

export const PaymentRequestReasonText = ({ paymentRequestReason }: { paymentRequestReason: PaymentRequestReason }) => (
    <LocalizedText textKey={PaymentRequestReasonTextKeyMap[paymentRequestReason]} />
);
